// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter, ReloadPage } from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import { constants } from "@stoneage/XDL/constants";

export const AddLanguageToLocalStorage: any = (props: any) => {
    const languageCode = props.parameter.languageCode;
    window.localStorage.setItem(constants.cookies.ptLanguage, languageCode);
};

export const XngReloadPage: any = (props: any) => {
    let href = window.location.href;
    const languageCode = props.parameter.languageCode;
    const prevLanguageCode = props.parameter.prevLanguageCode;
    const switchingLanguageParameter = `setcontextlanguagecode=`;
    const switchingLanguageParameterWithLangCode = `setcontextlanguagecode=${languageCode}`;
    if (!href.includes(switchingLanguageParameter)) {
        if (window.location.href.indexOf("?") === -1) {
            href += "?";
        } else {
            href += "&";
        }
        href += switchingLanguageParameterWithLangCode;
    } else {
        href = href.replace(prevLanguageCode, languageCode);
    }
    window.location.href = href;
};

addToChainAfter(chain, PopulateApiParameter, AddLanguageToLocalStorage);
replaceInChain(chain, ReloadPage, XngReloadPage);
